import {HomeLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {ParentFooterGroup} from "../groups/parent-footer.group";

export const ParentMenu = (context: NavigationContext) => [
    HomeLink(context),
    ParentFooterGroup(context)
];